module.exports = __webpack_public_path__ + "static/media/group-member.282ed7d3.svg";